import { DataStore } from '../../data/store';
import { DataColumn, DataWarning } from '../../types';
import { createChartData } from '../data/chartData';
import { ChartData, ColorHelper } from '../data/common';
import { formatChartSharedBrands } from '../utils';
import { validColumnsFilter } from './helper';

export function makeMultiKpiData(
  data: DataStore,
  options: {
    kpis: string[];
    xColumnName: string;
    dataWarnings: DataWarning[];
    requestedColumns: DataColumn[];
    sharedBrands?: string[];
  }
): ChartData[] | undefined {
  const { kpis, xColumnName, requestedColumns, sharedBrands } = options;

  if (!data) {
    return;
  }

  const columns = data.getDataColumns();

  const xData = data.getGroupedData([xColumnName])[0];
  const totalsData = data.getGroupedData([])[0];
  const currency = data.getCurrency();
  const fieldWarnings = data.getDataWarnings(kpis);

  if (!xData || !totalsData) {
    return;
  }

  formatChartSharedBrands(xColumnName, xData, sharedBrands);

  const colorHelper = new ColorHelper(
    xColumnName,
    xData.data.map(r => String(r.values[xColumnName]))
  );

  const datas: ChartData[] = [];

  // make sure we have valid columns only (sync functionality can add invalid columns)
  const kpiColumns = requestedColumns.filter(validColumnsFilter);

  kpiColumns.forEach(column => {
    const kpiData = createChartData(
      { rows: xData.data, columns, totals: totalsData.data[0], fieldWarnings },
      {
        yColumnName: column.name,
        xColumnName,
        currency,
        includeTotals: true,
        setPerRow: true,
        colorHelper,
      }
    );
    if (kpiData) {
      kpiData.dataLabels = xData.timeFrame.periods.map(v => (Array.isArray(v.name) ? v.name : v.name.split(' ')));
      datas.push(kpiData);
    } else {
      datas.push({
        yColumn: column,
        dataLabels: [],
      } as ChartData);
    }
  });

  return datas.length > 0 ? datas : undefined;
}
